import { FC } from 'react';
import { IconProps } from '@components/common/Icons/types';

export const ArrowRightIcon: FC<IconProps> = ({ width = '18', height = '18', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path d='M1.5 9H16.5' stroke={'currentColor'} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M11.25 3.75L16.5 9L11.25 14.25'
      stroke={'currentColor'}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
